import React, { FC } from 'react';
import { Checkbox, CheckboxProps } from '@chakra-ui/react';
import { useCheckoutDispatch, useCheckoutState } from '@olo-web/client-state';

export const ContactlessDeliveryCheckbox: FC<CheckboxProps> = (props) => {
  const { isContactlessDelivery } = useCheckoutState();
  const checkoutDispatch = useCheckoutDispatch();

  const handleChange = () => {
    checkoutDispatch({
      type: 'SET_IS_CONTACTLESS_DELIVERY',
      payload: !isContactlessDelivery,
    });
  };

  return (
    <Checkbox
      display="flex"
      flexDir="row-reverse"
      colorScheme="primary"
      onChange={handleChange}
      isChecked={isContactlessDelivery}
      fontWeight="600"
      w={{ base: '100%', md: 'auto' }}
      data-testid="contactless-delivery-checkbox"
      {...props}
    >
      Contactless delivery
    </Checkbox>
  );
};
